<template>
  <Offers />
</template>

<script>
import Offers from '../components/Offers.vue';

export default {
  components: {
    Offers,
  },
  data() {
    return {
      disableCard: false,
    };
  },
}
</script>
